import React, { useEffect } from "react";
import Routes from "./Routes";
import { AuthProvider } from "./contexts/AuthContext";
import { PortfolioDataProvider } from "./contexts/PortfolioDataContext";
import { initNewUserCleanup } from "./lib/clearNewUserPortfolio";

function App() {
  useEffect(() => {
    // Initialize cleanup subscription that will run once for newly-created users
    const sub = initNewUserCleanup();
    return () => {
      // unsubscribe on unmount if subscription present
      try {
        if (sub && sub.subscription) sub.subscription.unsubscribe?.();
        if (sub && typeof sub?.unsubscribe === 'function') sub.unsubscribe();
      } catch (e) {
        // ignore
      }
    };
  }, []);

  return (
    <AuthProvider>
      <PortfolioDataProvider>
        <div className="app-shell">
          <div className="absolute inset-0 aurora-blob opacity-50" aria-hidden="true" />
          <div className="absolute inset-0 tile-grid" aria-hidden="true" />
          <div className="relative z-10">
            <Routes />
          </div>
        </div>
      </PortfolioDataProvider>
    </AuthProvider>
  );
}

export default App;